module.exports = __webpack_public_path__ + "img/宝武碳钢.2b643179.png";